export const solutions = [
  {
    number: '01',
    title: 'Fuel Monitoring & Prevention',
    verticalTitle: 'Fuel Monitoring',
    icon: '⛽',
    imageKey: 'fuelMonitoring',
    href: '/section-5',
    text: 'Cut fuel costs by up to 30% with real-time monitoring solutions to prevent theft, control costs, and optimize efficiency with advanced sensors and analytics.',
  },
  {
    number: '02',
    title: 'Fuel Automation',
    verticalTitle: 'Fuel Automation',
    icon: '⚙️',
    imageKey: 'fuelAutomation',
    href: '/section-3',
    text: 'Robust analytics and reporting tools with real-time alerts for fuel theft, discrepancies, and inventory levels. Secure role-based access with complete audit trails.',
  },
  {
    number: '03',
    title: 'Construction Fuel Monitoring',
    verticalTitle: 'Construction Fuel Monitoring',
    icon: '🏗️',
    imageKey: 'constructionFuel',
    href: '/section-4',
    text: 'Boost operational efficiency and cut fuel losses in construction projects with real-time tracking of fuel levels across all machinery using weatherproof sensors.',
  },
  {
    number: '04',
    title: 'AIS-140 ICAT Certified Devices',
    verticalTitle: 'AIS-140 ICAT Certified Devices',
    icon: '📡',
    imageKey: 'aisDevice',
    href: '/section-1',
    text: 'State-of-the-art intelligent transport system for enhanced safety, efficiency, and control of your vehicle fleet. Government approved with embedded eSIM.',
  },
  {
    number: '05',
    title: 'Smart Waste Management',
    verticalTitle: 'Smart Waste Management',
    icon: '♻️',
    imageKey: 'wasteManagement',
    href: '/section-7',
    text: 'Transforming waste management with IoT technology for efficient monitoring, tracking, and optimization of your waste collection operations.',
  },
  {
    number: '06',
    title: 'Vehicle Tracking & Fleet',
    verticalTitle: 'Vehicle Tracking & Fleet',
    icon: '🚚',
    imageKey: 'vehicleTracking',
    href: '/section-9',
    text: 'Real-time GPS tracking, driver behavior monitoring, and intelligent analytics to enhance efficiency and safety across your fleet operations.',
  },
  {
    number: '07',
    title: 'Consignment Tracking',
    verticalTitle: 'Consignment Tracking',
    icon: '📦',
    imageKey: 'consignmentTracking',
    href: '/section-2',
    text: 'Real-time monitoring and management of shipments across various transportation modes, providing unparalleled visibility and control of your supply chain.',
  },
  {
    number: '08',
    title: 'Video Telematics',
    verticalTitle: 'Video Telematics',
    icon: '📹',
    imageKey: 'videoTelematics',
    href: '/section-10',
    text: 'Experience 360° Visual Fleet Supervision with our advanced video monitoring capabilities, including Driver Monitoring System (DMS) and ADAS.',
  },
  {
    number: '09',
    title: 'School Monitoring System',
    verticalTitle: 'School Monitoring System',
    icon: '🏫',
    imageKey: 'schoolMonitoring',
    href: '/section-6',
    text: 'Ensuring student safety with real-time tracking and advanced monitoring technology. Features GPS tracking, RFID-based attendance, and parent notification systems.',
  },
];

export const processSteps = [
  {
    step: '01',
    title: 'Consultation & Analysis',
    text: 'We begin with a thorough assessment of your fleet operations, identifying pain points, inefficiencies, and specific requirements. Our experts work closely with your team to understand your business objectives and develop a tailored solution plan.',
  },
  {
    step: '02',
    title: 'Hardware Installation',
    text: 'Our certified technicians install all necessary hardware components across your fleet vehicles, ensuring proper placement and configuration. We use industry-leading equipment compatible with your existing systems for maximum reliability and performance.',
  },
  {
    step: '03',
    title: 'Software Setup & Integration',
    text: 'We configure our software platform to match your operational requirements, establishing geofences, alerts, reports, and user roles. The system is seamlessly integrated with your existing business applications for unified data flow and management.',
  },
  {
    step: '04',
    title: 'Training & Deployment',
    text: 'Comprehensive training sessions are conducted for your team members to ensure effective use of the system. We provide detailed documentation, video tutorials, and hands-on guidance to maximize adoption and proficiency.',
  },
  {
    step: '05',
    title: 'Ongoing Support & Optimization',
    text: 'Our relationship continues with dedicated support, regular system maintenance, and performance reviews. We continuously optimize your solution based on usage patterns and changing business needs, ensuring maximum ROI from your investment.',
  },
];

export const testimonials = [
  {
    name: 'Rajiv Sharma',
    role: 'Logistics Manager, Express Cargo Ltd.',
    text: "Implementing Indraq's fleet management solution has completely transformed our logistics operations. We've seen a 30% reduction in fuel costs and a significant improvement in delivery times. The real-time tracking and analytics have been game-changers for our business.",
  },
  {
    name: 'Priya Desai',
    role: 'Principal, Greenfield International School',
    text: 'The school bus monitoring system has provided peace of mind to both parents and our administration. With real-time tracking and RFID attendance, we know exactly where our students are at all times. The parent app has received overwhelmingly positive feedback from our community.',
    featured: true,
  },
  {
    name: 'Vikram Singh',
    role: 'Operations Director, Buildtech Construction',
    text: 'The fuel monitoring system detected theft that was costing us lakhs every month. Within the first quarter of implementation, we recouped our entire investment. The analytics dashboard provides invaluable insights into consumption patterns across our entire construction fleet.',
  },
  {
    name: 'Ananya Patel',
    role: 'Municipal Commissioner, Surat',
    text: "The waste management solution has revolutionized our municipal operations. With real-time tracking of collection vehicles and digital confirmation of bin pickups, we've improved service quality while reducing operational costs by 25%. Citizen complaints have dropped dramatically.",
  },
];

export const stats = [
  { value: '500+', label: 'Happy Clients' },
  { value: '25+', label: 'Cities Covered' },
  { value: '10K+', label: 'Devices Deployed' },
  { value: '98%', label: 'Customer Satisfaction' },
];
